module.exports = __webpack_public_path__ + "static/media/Bulk Upload MOQ Dealshub B2B.c4ca341e.xlsx";